angular.module('impactx.search').controller('SearchDialogCtrl', [
    '$scope', '$mdDialog', 'themeFactory', 'searchFilter', '$redirect', SearchDialogCtrl
]);

function SearchDialogCtrl($scope, $mdDialog, themeFactory, searchFilter, $redirect) {
    $scope.search = function () {
        $scope.hide();
        $redirect.redirectTo(null, "/search.product");
    };
    $scope.selectFilter = function (filter) {
        $scope.data.supplier.value = filter.searchFilter.supplier.value;
        $scope.data.manufacturer.value = filter.searchFilter.manufacturer.value;
        $scope.data.contractNo.value = filter.searchFilter.contractNo.value;
        $scope.data.supplierNo.value = filter.searchFilter.supplierNo.value;
        $scope.data.priceRange.minValue = filter.searchFilter.priceRange.minValue;
        $scope.data.priceRange.maxValue = filter.searchFilter.priceRange.maxValue;
        $scope.data.category.selected.id = filter.searchFilter.category.selected.id;
        searchFilter.searchInput = filter.searchFilter.searchInput.value;
        searchFilter.setSearchFilterData($scope.data);
    };
    $scope.deleteSearchFilterData = function () {
        searchFilter.deleteSearchFilterData();
    };
    $scope.data = searchFilter.getSearchFilterData();
    if (!$scope.data.priceRange.maxValue) {
        $scope.data.priceRange.maxValue = 0;
    }
    $scope.searchFilter = searchFilter;
    $scope.theme = themeFactory.getTheme();
    $scope.hide = function () {
        $mdDialog.hide();
    };
}